type EnergySubSiteSelection = {
  siteId: string;
  subSiteIds?: string[];
};

export function updateEnergySubSiteIds(
  { siteId, subSiteIds }: EnergySubSiteSelection,
  value: string,
  checked: boolean,
): string[] {
  if (checked) {
    return [...new Set([...(subSiteIds || [siteId]), value])];
  }

  return subSiteIds && subSiteIds.length > 1 ? subSiteIds.filter((id) => id !== value) : [siteId];
}

export function isEnergySubSiteChecked(
  { siteId, subSiteIds }: EnergySubSiteSelection,
  value: string | undefined,
): boolean {
  if (!value) {
    return false;
  }

  return subSiteIds?.includes(value.toString()) || ((!subSiteIds || subSiteIds.length === 0) && value === siteId);
}
